import styled from 'styled-components'
import theme from '@app/ui/theme'
import { fieldInputStyles } from '@app/components/molecules/FormFields/styled'

// One line per tee: its colour and name, then the two numbers that are the
// whole point of filling these in. Shared by the set of tees and the single
// tee, so a tee is filled in the same way wherever it is opened.
export const TeeGrid = styled.div`
  display: grid;
  grid-template-columns: 52px 1fr 110px 110px;
  gap: 10px 12px;
  align-items: center;
`

export const ColumnLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-align: center;
`

export const ColorCell = styled.div`
  display: flex;
  justify-content: center;
`

export const NameInput = styled.input<{ hasError?: boolean }>`
  ${fieldInputStyles}
  width: 100%;
  padding: 0 12px;
  border-color: ${(props) =>
    props.hasError ? theme.colors.warning : theme.colors.dark1};
`

export const NumberInput = styled.input<{ hasError?: boolean }>`
  ${fieldInputStyles}
  width: 100%;
  border-color: ${(props) =>
    props.hasError ? theme.colors.warning : theme.colors.dark1};
`
